<template>
  <div>
    <my-title :img='img' title='组织架构'></my-title>
    <div class="container">
      <el-image 
        style="width: 100%;"
        :src="item.file_path" 
        v-for="(item,index) in imgList"
        :key='index'
        :preview-src-list="[item.file_path]">
      </el-image>
    </div>
  </div>
</template>

<script>
import myTitle from '../../components/IntoTheGroup/IntoTheGroup_title'
import {selectcatfile} from '../../api/catfile/selectcatfile'
export default {
  data() {
    return {
      img: require('../../assets/img/icon_framework.png'),
      catId: 25,
      imgList: '',
    }
  },
  components: {
    myTitle
  },
  created () {
    this.getCatFile()
  },
  methods: {
    getCatFile() {
      selectcatfile({catId: this.catId}).then(res => {
        if(res.data.length === 0) return;

        this.imgList = res.data;
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  .container {
    text-indent: 0;
    padding-bottom: 30px;
    width: 1200px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  @media screen and (max-width: 1200px) {
    .container {
      width: 992px;
    }
  }
  @media screen and (max-width: 992px) {
    .container {
      width: 768px;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 90%;
    }
  }
</style>